import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  DefaultOptions,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { AUTH_TOKEN_KEY, GRAPHQL_URL } from '~/constants';

const httpLink = new HttpLink({
  uri: GRAPHQL_URL, // Replace with your endpoint
});

// Authentication middleware
const authLink = new ApolloLink((operation, forward) => {
  const token = sessionStorage.getItem(AUTH_TOKEN_KEY); // Example: Token management
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  });
  return forward(operation);
});

// Error handling
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-first',
  },
  query: {
    fetchPolicy: 'cache-first',
  },
};

// Create Apollo Client
const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Team: {
        keyFields: ['id'], // Normalize by ID
      },
    },
  }),
  devtools: {
    enabled: true, // Use this instead of connectToDevTools
  },
  defaultOptions,
});

export default client;
